require('./bootstrap');
window.Vue = require('vue');
import Vuex from 'vuex';
import { mapGetters } from 'vuex';
import PortalVue from 'portal-vue';
import lozad from 'lozad';
import Lego from '../../vendor/helix/lego/resources/js/store-front/store-front';

const store = new Vuex.Store({});
Vue.use(PortalVue);
Vue.use(Lego, store);

require('./components');
require('./safari');

Vue.config.ignoredElements = ['klarna-placement'];

window.vue = new Vue({
    el: '#app',
    store,

    computed: {
        ...mapGetters('navigation', ['mobileNavIsShowing']),
    },

    mounted() {
        const observer = lozad();
        observer.observe();
    },

    watch: {
        mobileNavIsShowing(showing) {
            if (showing) {
                document.body.style.setProperty('overflow', 'hidden');
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    },
});
